/**
 * AD inbound directories list page — URL search-param schema.
 *
 * Per CLAUDE.md "URL is the source of truth for list/filter state":
 * the only state today is the offset pager. Filters can grow here
 * later without touching the page component's props.
 */

import { z } from "zod";

export const adInboundListSearchSchema = z.object({
  offset: z.coerce.number().int().nonnegative().optional(),
});
export type AdInboundListSearch = z.infer<typeof adInboundListSearchSchema>;
